import AbstractController from '../../../../../../ig_template/Resources/Public/Src/Js/Controller/AbstractController';
import Controller from '../../../../../../ig_template/Resources/Public/Src/Js/Controller/Controller';
import IgMapController from '../../../../../../ig_map/Resources/Public/Src/Js/Controller/MapController';
import StoresMap from '../Elements/StoresMap';

/**
 * Map Controller
 *
 * @class
 */
class MapController extends AbstractController {
	/**
	 * @constructor
	 */
	constructor() {
		super();

		Controller.registerController(this);
		IgMapController.registerMaps(...StoresMap);
		this._registerElements(...StoresMap);
	}

	initializeMaps() {
		const registeredMaps = this._getRegisteredMaps();

		registeredMaps.forEach((map) => {
			map.initialize();
		});
	}
}

export default (new MapController);
